import { render, staticRenderFns } from "./UserRoleButtons.vue?vue&type=template&id=ce6e3b00&"
import script from "./UserRoleButtons.vue?vue&type=script&lang=js&"
export * from "./UserRoleButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports